import React from 'react';

const BusinessHours = ({ hours }) => {
  if (!hours || Object.keys(hours).length === 0) {
    return <p>No business hours available.</p>;
  }

  return (
    <div>
      <h3>Business Hours</h3>
      <ul>
        {Object.entries(hours).map(([day, time]) => (
          <li key={day}>
            <strong>{day}:</strong> {time}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default BusinessHours;
